import { __awaiter, __rest } from "tslib";
import React from 'react';
import { createStore } from '@souche-f2e/muji';
import { dispatch } from '@@/store';
import { showInfo } from '@/components';
import Authorized from '@/components/Auth/auth';
import { notification, Modal } from 'antd';
import Api from '@/services';
import Mapping from '@/shared/mapping';
const { finance } = Api;
const { depositWithdrawList, rejectDepositWithdraw, } = finance;
const { excelExportType } = Mapping;
const initState = {
    columns: [{
            title: '用户ID',
            dataIndex: 'userId',
            width: 150,
        }, {
            title: '经销商名称',
            dataIndex: 'distributor',
            width: 150,
            render: (text, record, index) => (<a href="javascript:;" onClick={() => dispatch.cashMargin.showDetails(record)}>
        {text}
      </a>),
        }, {
            title: '保证金总额（元）',
            dataIndex: 'balanceY',
            width: 200,
        }, {
            title: '提现保证金（元）',
            dataIndex: 'moneyY',
            render: (text, record, index) => {
                return Number(text) < 0 ? 0 : (<span>{text}</span>);
            },
            width: 200,
        }],
    waitTableColumns: [
        {
            title: '申请时间',
            dataIndex: 'createTime',
            width: 200,
        }, {
            title: '操作',
            dataIndex: 'option',
            width: 250,
            render: (text, record, index) => (<div>
          <Authorized allow={'psgjb-finanwithdraw-select'}>
            <a href="javascript:;" style={{ marginRight: '10px' }} onClick={() => dispatch.cashMargin.showPayModal(record)}>
              通过并退款
            </a>
            <a href="javascript:;" onClick={() => dispatch.cashMargin.showRejectModal(record)}>
              驳回
            </a>
          </Authorized>
        </div>),
        }
    ],
    rejectTableColumns: [{
            title: '驳回时间',
            dataIndex: 'modifyTime',
            width: 300,
        }],
    passTableColumns: [{
            title: '通过时间',
            dataIndex: 'modifyTime',
        }, {
            title: '操作',
            dataIndex: 'option',
            render: (text, record, index) => (<div>
        <a href="javascript:;" onClick={() => showInfo('deposit', record.id)}>
          查看
        </a>
      </div>),
        }],
    data: [],
    totalNum: 0,
    options: [
        { label: '待审批', value: '0' },
        { label: '已驳回', value: '2' },
        { label: '已通过', value: '1' },
    ],
    showPayConfirm: false,
    pageSize: 20,
    pageIndex: 1,
    noApprovalData: {},
    passData: {},
    rejectData: {},
    activeState: '0',
    searchData: {},
    loading: false,
    excelExportType,
};
export default createStore({
    state: Object.assign({}, initState),
    effects: {
        /**
         * 加载列表
         * 加载待付款列表与已付款列表，接口数量未知，暂定是一个接口；
         * 参数直接从Top里传就可以了；
         * */
        load(payload, { update, state, rootState }) {
            return __awaiter(this, void 0, void 0, function* () {
                // 待审核的列表
                // console.log('待审核');
                console.log('sousuo', payload);
                const { page } = payload, searchParams = __rest(payload, ["page"]);
                const { pageIndex, pageSize } = state;
                const params = Object.assign(Object.assign({}, searchParams), { currentIndex: page || pageIndex, pageSize });
                this.SET_STATE({
                    loading: true,
                });
                depositWithdrawList(params).then((res) => {
                    const { items, totalNumber } = res;
                    this.SET_STATE({
                        data: items,
                        totalNum: totalNumber,
                        pageIndex: page || pageIndex,
                    });
                }).finally(() => {
                    this.SET_STATE({
                        loading: false,
                    });
                });
                return;
                // const success = await marginData(payload);
                // return success;
            });
        },
        /** 搜索列表 */
        onChange(payload, { update, state, rootState }) {
            this.SET_STATE({
                activeState: payload,
            });
            // 更改Top Form里的搜索项名称以及置空
            dispatch.cashTop.SET_STATUS(payload);
            dispatch.cashTop.CLEAR_SEARCH();
            // 请求接口获取表格数据；
            // 此时获取的是全部的数据
            this.load({ status: payload, page: 1 });
        },
        showRejectModal(data) {
            Modal.confirm({
                title: '您确定要驳回吗？',
                onOk() {
                    dispatch.cashMargin.toReject(data);
                },
            });
        },
        /** 驳回 */
        toReject(payload, { update, state, rootState }) {
            return __awaiter(this, void 0, void 0, function* () {
                // 调用驳回接口
                rejectDepositWithdraw({ id: payload.id }).then((res) => {
                    if (res) {
                        notification.success({
                            message: '保证金提现申请驳回',
                            description: '结果将返回给用户！',
                        });
                        dispatch.cashMargin.GET_CURRENT_PAGE();
                        dispatch.cashMargin.load({ status: 0 });
                    }
                    else {
                        notification.warn({
                            message: '保证金提现申请驳回失败',
                        });
                    }
                });
            });
        },
        // 通过并退款
        showPayModal(payload, { state }) {
            dispatch.payMoneyModal.getPayRadios({ type: 'applyRefund' });
            this.SHOW_PAYCONFIRM(payload);
        },
        showDetails(payload, { state }) {
            const type = payload.buyerTag === 1 ? 'buyer' : 'seller';
            showInfo(type, payload.userId);
        },
    },
    reducers: {
        RESET_STATE() {
            return Object.assign({}, initState);
        },
        SET_STATE(state, payload) {
            Object.keys(payload)
                .forEach((key) => {
                if (initState[key] !== undefined) {
                    state[key] = payload[key];
                }
            });
        },
        SHOW_PAYCONFIRM(state, payload) {
            // dispatch.payMoneyModal.getPayRadios({type:'refund'})
            state.showPayConfirm = true;
            state.noApprovalData = payload;
        },
        HIDE_PAYCONFIRM(state, payload) {
            state.showPayConfirm = false;
        },
        GET_CURRENT_PAGE(state) {
            const page = state.noApprovalData.length;
            const currentIndex = state.pageIndex;
            if (page === 1) { // 当前页只剩余1条数据
                state.pageIndex = currentIndex > 1 ? currentIndex - 1 : 1;
            }
        },
    },
});
